import { sendGet, sendPost, sendPut } from './axios';

// eslint-disable-next-line import/prefer-default-export
export const loadResource = () => sendGet('/resource');
export const getListLanguageByEnvironment = () => sendGet('/language/get-file-language');
